import * as React from "react";
const SvgTriangleDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 6H11L7.5 10.5L4 6Z", fill: "currentColor" }));
export default SvgTriangleDown;
